var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFoundImgM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 163,
    viewBox: "0 0 200 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.43 32H74.2871C68.7643 32 64.2871 36.4771 64.2871 42V112C64.2871 117.523 68.7643 122 74.2871 122H146.43C151.953 122 156.43 117.523 156.43 112V42C156.43 36.4771 151.953 32 146.43 32Z",
    fill: "#E4EFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.287 71.9999H109.316",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.287 52H69.2871C61.0028 52 54.2871 58.7156 54.2871 67V117C54.2871 125.284 61.0028 132 69.2871 132H119.287C127.571 132 134.287 125.284 134.287 117V67C134.287 58.7156 127.571 52 119.287 52Z",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2871 107L74.2871 87.0002C76.5673 84.806 79.154 83.6508 81.7871 83.6508C84.4201 83.6508 87.0068 84.806 89.2871 87.0002L114.287 112",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.287 102L109.287 97.0001C111.567 94.806 114.154 93.6508 116.787 93.6508C119.42 93.6508 122.007 94.806 124.287 97.0001L134.287 107",
    stroke: "#A2B4B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 132.714H17.1428",
    stroke: "#A2B4B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.142 32H199.285",
    stroke: "#A2B4B9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFoundImgM);
export default __webpack_public_path__ + "static/media/NoFoundImgM.75e5b382277f1c44dab4fc8ea4165884.svg";
export { ForwardRef as ReactComponent };